import { GET_FISH_TYPES_LOADING, GET_FISH_TYPES_SUCCESS } from '../actionTypes';
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';

export const getFishTypesSuccess = payload => {
    return ({
        type: GET_FISH_TYPES_SUCCESS,
        payload
    })
}

export const getFishTypesAsync = payload => dispatch => {
    return client.service('fish-types').find()
		.then((response) => {
            dispatch(getFishTypesSuccess(response));
            return response
		})
        .catch((error) => {
            console.error('error', error);
        })
           
}